import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import PaintHero from './components/PaintHero';
import PaintTierComparison from './components/PaintTierComparison';
import PaintFeatures from './components/PaintFeatures';
import ContactCTA from '../components/ContactCTA';

export default function PaintPage() {
  return (
    <div className="min-h-screen bg-[#1A1A1A]">
      <Navbar />
      <PaintHero />
      <PaintTierComparison />
      <PaintFeatures />
      <ContactCTA />
      <Footer />
    </div>
  );
}